module Meevo.Plugins.MiscSupplyDefinitions {
    "use strict";

    import Distributor = Meevo.Model.Distributor;
    import IMiscSupplyDefinition = Meevo.Model.IMiscSupplyDefinition;
    import SupplyCategoryEnum = Meevo.Model.SupplyCategoryEnum;
    import ModalTranslationModes = Meevo.Components.Modal.ModalTranslationModes;
    import ProductInventoryTypeEnum = Meevo.Model.ProductInventoryTypeEnum;

    enum ValidityEnum {
        displayName,
        sku,
        barCode
    }

    /**
    * Main Section of Client 
    */

    export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<IMiscSupplyDefinition> {

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            identityService: Meevo.Components.Common.IIdentityService,
            noun: Meevo.Model.NounEnum,
            protected modalService: Meevo.Components.Modal.IModalService,
            sectionSecurityKey?: string
        ) {
            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, identityService, noun, null, sectionSecurityKey);
        }

        public distributor: Object = null;
        public parametrs = {
            isDisplayNameValid: true,
            isSKUValid: true,
            isBarcodeValid: true
        }

        /**
        * Base class override which defines what a DEFAULT model looks like.
        */
        createSectionModelInstance(postAdd: (data: any) => any): void {
            this.dataService.getTemplate(this.baseEndpoint).then((data) => {
                this.model = data;
            });
        }

        addDistributor(): void {
            this.model.distributors.push(this.distributor);
            this.distributor = null;
        }

        removeDistributor(index: number): void {
            this.model.distributors.splice(index, 1);
        }

        checkValidate(validity: ValidityEnum, value: string, id?: Guid): void {
            if (!value) return;

            let modalText = '',
                field,
                url: string;

            if (validity === ValidityEnum.displayName) {
                modalText = "ERROR_DISPLAYNAME_MISCELLANEOUS_SUPPLY";
                field = 'isDisplayNameValid';
                url = 'api/Product/Validate/DisplayName/';
            } else if (validity === ValidityEnum.sku) {
                modalText = "ERROR_SKU_MISCELLANEOUS_SUPPLY";
                field = 'isSKUValid';
                url = 'api/Product/Variant/Validate/Sku/';
            } else if (validity === ValidityEnum.barCode) {
                modalText = "ERROR_BARCODE_MISCELLANEOUS_SUPPLY";
                field = 'isBarcodeValid';
                url = 'api/Product/Variant/Validate/BarCode/';
            }
            let objCriteria = {
                [ValidityEnum[validity]]: value,
                variantId: id,
                isMiscSupply: true
            }

           // if (this.originalEntity && this.originalEntity[ValidityEnum[validity]] === this.model[ValidityEnum[validity]]) return;

            this.dataService.customMethodData(url, 'POST', objCriteria).then((response) => {
                this.parametrs[field] = !response.data;

                if (!this.parametrs[field]) {
                    this.modalService.alert(modalText, ModalTranslationModes.Translate);
                }
            });
        }

        preSave(): void {
            this.model['variants'][0].productInventoryType = ProductInventoryTypeEnum.Other;
            this.model['variants'][0]['notForSale'] = true;
           // this.model['variants'][0]['isInventoryTrackable'] = 1;
        }

        get validityEnum(): any {
            return ValidityEnum
        }
    }
}